import { getAccessToken } from "./services";

const IMPERSONATED_BY_KEY = "impersonatedBy";

/**
 * Preuzeta sesija: naše osoblje je prijavljeno kao klijentov korisnik.
 *
 * Sam token nosi `impersonated_by` s id-em djelatnika, ali ne i njegovo ime, pa se ime pamti
 * uz njega. Ime je samo za prikaz — je li sesija preuzeta odlučuje token, ne ovaj zapis.
 */
export const setImpersonatedBy = (name: string | null): void => {
  if (name) {
    sessionStorage.setItem(IMPERSONATED_BY_KEY, name);
  } else {
    sessionStorage.removeItem(IMPERSONATED_BY_KEY);
  }
};

export const getImpersonatedByName = (): string | null =>
  sessionStorage.getItem(IMPERSONATED_BY_KEY);

export const clearImpersonation = (): void => {
  sessionStorage.removeItem(IMPERSONATED_BY_KEY);
};

/** Sadržaj JWT-a bez provjere potpisa — služi samo prikazu, poslužitelj ionako provjerava sve. */
const readTokenPayload = (token: string | null = getAccessToken()): Record<string, any> | null => {
  if (!token) return null;

  try {
    const payload = token.split(".")[1];

    if (!payload) return null;

    const normalized = payload.replace(/-/g, "+").replace(/_/g, "/");

    return JSON.parse(decodeURIComponent(escape(window.atob(normalized))));
  } catch {
    return null;
  }
};

/** Je li trenutna sesija preuzeta. Čita se iz tokena, ne iz onoga što je zapisano uz njega. */
export const isImpersonating = (): boolean => {
  const payload = readTokenPayload();

  return !!payload?.impersonated_by;
};

/** Je li zadani token iz preuzete sesije. */
export const isImpersonationToken = (token: string | null): boolean =>
  !!readTokenPayload(token)?.impersonated_by;

/** Ime korisnika u čijem smo računu, iz tokena. */
export const getImpersonatedUserName = (): string => {
  const payload = readTokenPayload();

  if (!payload) return "";

  const claims = [
    payload["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/givenname"],
    payload["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/surname"],
  ];

  return claims.filter(Boolean).join(" ").trim();
};
